export const REG_REQUEST = 'REG_REQUEST';
export const REG_SUCCESS = 'REG_SUCCESS';
export const REG_ERROR = 'REG_ERROR';
export const SEND_CODE_REQUEST = 'SEND_CODE_REQUEST';
export const SEND_CODE_SUCCESS = 'SEND_CODE_SUCCESS';
export const SEND_CODE_ERROR = 'SEND_CODE_ERROR';
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
